export default __webpack_public_path__ + "7fd9573809706f0d3fc924b8d0a420a9.png";